import { render } from "./Spinner.vue?vue&type=template&id=227e1524&scoped=true"
import script from "./Spinner.vue?vue&type=script&lang=js"
export * from "./Spinner.vue?vue&type=script&lang=js"

import "./Spinner.vue?vue&type=style&index=0&id=227e1524&lang=scss&scoped=true"

import exportComponent from "/builds/rgLPqy5NH/0/rockwool/super-wykonawca-2022/performer-rating-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-227e1524"]])

export default __exports__